module.exports = __webpack_public_path__ + "068f398607ec588dc1d231874fb63d82.jpg";